module.exports = __webpack_public_path__ + "static/media/11.jpg.0de9c470.webp";